<template>
  <div id="dashboard" class="dashboard">
    <div class="row dashboard__row">
      <div class="col-md-12">
        <NewsBannersCard></NewsBannersCard>
      </div>
    </div>
    <div class="row dashboard__row">
      <div class="col-md-12" v-for="permission in fullWidthCards">
        <component :is="cardName(permission.perm_desc)"></component>
      </div>
    </div>
    <div class="row dashboard__row">
      <div class="col-6 col-md-6" v-for="permission in halfWidthCards">
        <component :is="cardName(permission.perm_desc)"></component>
      </div>
      <div class="col-6 col-md-6">
        <ConnectionsCard></ConnectionsCard>
      </div>
    </div>
  </div>
</template>

<script>
  import lodash from 'lodash';
  import { mapGetters } from 'vuex';
  import FuelUtilizationCard from '../dashboard/cards/FuelUtilizationCard.vue';
  import FuelUtilizationSummaryCard from '../dashboard/cards/FuelUtilizationSummaryCard.vue';
  import RecentInProgressCard from '../dashboard/cards/RecentInProgressCard.vue';
  import PurchaseActivityCard from '../dashboard/cards/PurchaseActivityCard.vue';
  import ConnectionsCard from '../dashboard/cards/ConnectionsCard.vue';
  import NewsBannersCard from '../dashboard/cards/NewsBannersCard.vue';
  import AudiologyKpisCard from '../dashboard/cards/AudiologyKpisCard.vue';
  import PricingGuidesCard from '../dashboard/cards/PricingGuidesCard.vue';
  import DigitalPromoCard from '../dashboard/cards/DigitalPromoCard.vue';
  import FuelFundsCard from '../dashboard/cards/FuelFundsCard.vue';
  import MeetingAgendaCard from '../dashboard/cards/MeetingAgendaCard.vue';

  export default {
    name: 'DashboardLayout',
    components: {
      FuelUtilizationCard,
      FuelUtilizationSummaryCard,
      RecentInProgressCard,
      PurchaseActivityCard,
      AudiologyKpisCard,
      PricingGuidesCard,
      DigitalPromoCard,
      FuelFundsCard,
      ConnectionsCard,
      MeetingAgendaCard,
      NewsBannersCard,
    },
    data() {
      return {
        fullWidth: [
          'can_view_fuel_utilization',
          'can_view_purchase_activity',
        ],
        halfWidth: [
          'can_view_audiology_kpis',
          'can_view_pricing_guides',
          'can_view_fuel_funds',
          'can_view_digital_promo',
          'can_view_meeting_agenda',
        ],
      };
    },
    mounted() {
      this.$store.dispatch('banners/getBanners')
        .then(() => {
          this.$store.dispatch('main/setProperty', { key: 'globalLoading', value: false });
        })
    },
    computed: {
      ...mapGetters('main', ['menuItems']),
      fullWidthCards() {
        return lodash.filter(this.menuItems, (item) => {
          return this.fullWidth.includes(item.perm_desc)
            && lodash.map(this.menuItems, 'perm_desc').includes(item.perm_desc);
        });
      },
      halfWidthCards() {
        return lodash.filter(this.menuItems, (item) => {
          return this.halfWidth.includes(item.perm_desc)
            && lodash.map(this.menuItems, 'perm_desc').includes(item.perm_desc);
        });
      },
      canViewFuelUtilization() {
        return lodash.map(this.menuItems, 'perm_desc').includes('can_view_fuel_utilization');
      },
    },
    methods: {
      cardName(permission) {
        return `${lodash.camelCase(permission).replace('canView', '')}Card`;
      },
    },
  };
</script>
